module.exports = __webpack_public_path__ + "media/images/icons/flags/PT-aca9c3394de5d8b396f2fc34b62caf65.svg";